import { action, type Action } from 'easy-peasy'
import type { BillEntryData } from '@strata-monorepo/shared-ui/components/BillEntry/BillEntry'

export interface ManualBillsModel {
  // States
  manualData: BillEntryData[]

  // Actions
  addNewManualEntry: Action<ManualBillsModel>
  setManualData: Action<ManualBillsModel, BillEntryData[]>
}

export const manualBillsModel = (): ManualBillsModel => ({
  // States
  manualData: [],

  // Actions
  addNewManualEntry: action((state) => {
    const newEntry: BillEntryData = {
      usage: null,
      month: '',
      day: null,
      year: null,
      address: '',
      billing: null,
      planName: '',
      source: 'manual',
      isSubmitted: false,
      isEditing: false,
    }
    const updatedEntries = [...state.manualData, newEntry]
    state.manualData = updatedEntries
  }),

  setManualData: action((state, payload) => {
    state.manualData = payload
  }),
})
